"use client";

import { LoadingSkeleton } from "@faire/web/slate-deprecated/LoadingSkeleton";
import { Flex } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { CTATile } from "@faire/web/ui-labs/Carousel/__internal__/CTATile";
import { Carousel } from "@faire/web/ui-labs/Carousel/Carousel";
import React from "react";

// This is a lazy loaded component that loads the CSS slate styles for the page as the native-styles.css break homepage prefetching

export const SlateNativeStyles: React.FC = () => {
  void LoadingSkeleton;
  void Carousel;
  void Flex;
  void CTATile;
  void Spacer;
  void Typography;
  return null;
};
